import React from "react";
import {Text, Pressable, SafeAreaView, ScrollView, StyleSheet, View} from "react-native";
import {SettingsItem} from "../component/SettingsItem";
import {useSelector} from "react-redux";
import '../function/i18n';
import {useTranslation} from 'react-i18next';
import {useNavigation, useTheme} from "@react-navigation/native";

export const SettingsScreen = () => {
    const settings = useSelector(state => state.settings);
    const lang = useSelector(state => state.lang);
    const _theme = useSelector(state => state.theme);
    const {t, i18n} = useTranslation();
    const navigation = useNavigation();
    const theme = useTheme();
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            backgroundColor: theme.colors.scheme[3],
            alignItems: 'center',
            justifyContent: 'center',
        },
        list: {
            maxWidth: 800,
            flexGrow:1,
            padding: 8
        },
        settingsWrapper: {
            width:'100%',
            display:'flex',
            flexDirection:'row',
            flexWrap:'wrap'
        },
        button: {
            display:'flex',
            flexDirection:'row',
            backgroundColor:theme.colors.scheme[4],
            borderRadius:24,
            justifyContent:'center',
            padding:12,
            marginBottom:12,
            borderWidth:2,
            borderColor:theme.colors.scheme[5]
        }
    });

    return(
        <SafeAreaView style={styles.container}>
            <ScrollView contentContainerStyle={[styles.list]}>
                <Pressable onPress={() => {navigation.navigate('Lang')}} style={({pressed}) => [styles.button]}><Text style={{color:theme.colors.scheme[2]}}>{t('lang.button')}: </Text><Text style={{color:theme.colors.scheme[2]}}>{t('lang.list.'+lang)}</Text></Pressable>
                {/*<Pressable onPress={() => {navigation.navigate('Theme')}} style={({pressed}) => [styles.button]}><Text style={{color:theme.colors.scheme[2]}}>{t('theme.button')}: </Text><Text style={{color:theme.colors.scheme[2]}}>{t('theme.list.'+_theme)}</Text></Pressable>
                */}
                <View style={styles.settingsWrapper}>
                {
                    Object.keys(settings).map((prop, key) => {
                        return (settings[prop].visible ? <View key={key} style={{width:'100%'}}><SettingsItem prop={prop} title={t('settings.list.'+prop+'.title')} description={t('settings.list.'+prop+'.description')} enabled={settings[prop].enabled}></SettingsItem></View> : null)
                    })
                }
                </View>
            </ScrollView>
        </SafeAreaView>
    )
}